import { EditIcon } from '@calizahq/react-components-v2'
import React from 'react'

import { BottomSheet, Card, LineItem } from '@/components'
import { UpdateReservationAccessCodes } from '@/forms/Reservation/UpdateAccessCodes'
import { useToggle } from '@/hooks'
import { HomeQualityCheckReservation } from '@/types/HomeQualityCheck'

export const ReservationAccessCodes = ({
  allowUpdates,
  header,
  refetchOnSuccess,
  reservation,
}: {
  allowUpdates: boolean
  header: string
  refetchOnSuccess?: () => void
  reservation?: HomeQualityCheckReservation
}) => {
  const { isShown: showUpdateReservationAccessCodes, toggle: toggleUpdateReservationAccessCodes } = useToggle()

  return (
    <>
      <Card
        cardClassName="mb-4"
        header={ReservationAccessCodeHeader(allowUpdates, header, toggleUpdateReservationAccessCodes)}
      >
        {reservation &&
        (reservation.hostDoorAccessCode ||
          reservation.memberDoorAccessCode ||
          reservation.lockboxCode ||
          reservation.lockboxBackupCode ||
          reservation.intercomCode) ? (
          <div className="flex w-full flex-col px-4">
            {reservation.hostDoorAccessCode ? (
              <LineItem label="Host Door Access Code" value={reservation.hostDoorAccessCode} />
            ) : null}
            {reservation.memberDoorAccessCode ? (
              <LineItem label="Member Door Access Code" value={reservation.memberDoorAccessCode} />
            ) : null}
            {reservation.lockboxCode ? <LineItem label="Lockbox Code" value={reservation.lockboxCode} /> : null}
            {reservation.lockboxBackupCode ? (
              <LineItem label="Lockbox Backup Code" value={reservation.lockboxBackupCode} />
            ) : null}
            {reservation.intercomCode ? <LineItem label="Intercom Code" value={reservation.intercomCode} /> : null}
          </div>
        ) : (
          <div className="flex w-full flex-col p-4">
            <p className="text-p-sm italic text-secondary">No Information Available</p>
          </div>
        )}
      </Card>
      <BottomSheet isVisible={showUpdateReservationAccessCodes} onClose={toggleUpdateReservationAccessCodes}>
        {reservation ? (
          <UpdateReservationAccessCodes
            closeModal={toggleUpdateReservationAccessCodes}
            refetchOnSuccess={refetchOnSuccess}
            reservation={reservation}
          />
        ) : null}
      </BottomSheet>
    </>
  )
}

const ReservationAccessCodeHeader = (allowUpdates, header, toggleUpdateReservationAccessCodes) => (
  <>
    <p className={`font-bold text-p-sm leading-120`}>{header}</p>

    {allowUpdates ? (
      <button
        className={'mr-2 grid h-5 w-5 items-center justify-center'}
        onClick={toggleUpdateReservationAccessCodes}
        title="Edit Access Codes"
      >
        <EditIcon className="w-4 cursor-pointer icon-secondary" />
      </button>
    ) : null}
  </>
)
